import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import {User} from '../../models/user';
import {AngularFireAuth} from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { HomePage } from '../home/home';
import { CoolLocalStorage } from 'angular2-cool-storage';
import { ScorePage } from '../score/score';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  user = {} as User;
  error: any;
  myForm: FormGroup;
  clouduser: FirebaseObjectObservable<any>;
  cloud: FirebaseObjectObservable<any>;
  localStorage: CoolLocalStorage;

  constructor(private db: AngularFireDatabase, private fb:  FormBuilder, private afauth: AngularFireAuth, public navCtrl: NavController, public navParams: NavParams, menuCtrl: MenuController, localStorage: CoolLocalStorage)
  {
      this.user.score = 0;
      this.localStorage = localStorage;
      menuCtrl.enable(false);
      this.user.admin = false;

  }

  ngOnInit() {
      this.myForm = this.fb.group({
        email: ['', [Validators.required, Validators.pattern('[a-z0-9.@]*')]],
        password: ['', [Validators.required]],
        name: ['', [Validators.required]],
        district: ['', [Validators.required]],
        code: ['', [Validators.required]]
      });
  }

   onSubmit()
   {
      try{
        const result =  this.afauth.auth.createUserWithEmailAndPassword(this.user.email, this.user.password)
        .catch(error => {this.error = error.message;})
        .then(user => { if(user){this.setup(user);}})
      }
      catch(e)
      {
        console.error(e);
        this.error = e.message;
      }
   }

   setup(user)
   {

     this.clouduser = this.db.object('/v2/users/' +  user.uid);
     this.cloud =  this.db.object('/v2/users/' + this.user.code + '/' +  user.uid);
     this.localStorage.setItem('code', this.user.code);

     const cloud1 = this.clouduser.set(this.user);

     cloud1
       .then(_ => {

         console.log("first");
         const cloud2 = this.cloud.set(this.user);

         cloud2
         .then(_ => {
            console.log("second");
            this.navCtrl.setRoot(ScorePage);
         })
         .catch(err => console.log(err, 'You dont have access!'));
       })
       .catch(err => console.log(err, 'You dont have access!'));

   }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts